import React from "react";
import { Row, Col } from "antd";
import { PriceFormInput } from "components/ratecard/_common";

interface Props {
  name: string;
  currency: string;
}

const EditInline: React.FC<Props> = ({ name, currency }) => {
  return (
    <Row gutter={30}>
      <Col>
        <PriceFormInput label="Amount" name={name}>
          <PriceFormInput.PriceInput />
        </PriceFormInput>
      </Col>
      <Col style={{ display: "flex", alignItems: "flex-end" }}>
        <PriceFormInput label="Currency">{currency}</PriceFormInput>
      </Col>
    </Row>
  );
};

export default EditInline;
